import loadable from '@loadable/component';

export default loadable(
  () => import(/* webpackChunkName: "app-install-nudge" */ './View')
);
